import React from 'react';
import type { LoginPage as Props } from './login-page.types';

const LoginPage: React.FC<Props> = () => <React.Fragment />;

export default LoginPage;
